import React from 'react'

function SedeInfo({sedeData}) {
  return (
    <div className='container'>
        <div className='row'>
            <div className='col-sm-12 col-md-6 my-2'>
            <span className='small text-muted d-block mb-1'><b>Indirizzo</b></span>
               <span className='d-block'>{sedeData.descrizione || 'N/A'}</span>
            </div>
        </div>
    </div>
  )
}

export default SedeInfo;